__turbopack_context__.v({
  "component": "style-module-scss-module__V8r6EG__component",
  "heading": "style-module-scss-module__V8r6EG__heading",
  "statsGrid": "style-module-scss-module__V8r6EG__statsGrid",
});
